
import cx from 'classnames';

import { AnyElement, PropsOf } from '@/utils/types';

type ContainerProps<T> = PropsOf<T> & {
  as?: T;
  children?: React.ReactNode;
};

const Container = <T extends AnyElement>({
  as: Tag,
  children,
  className,
  ...rest
}: ContainerProps<T>) => {
  const ContainerTag = (Tag || 'div') as React.ElementType;
  const classNames = cx('container m-auto', className);

  return (
    <ContainerTag className={classNames} {...rest}>
      {children}
    </ContainerTag>
  );
};

export default Container;
